import React from 'react';
import { HeaderIcon } from '@amount/frontend-components';

import { IDrawerAnchor } from '.';

export const DrawerAnchor: React.FC<IDrawerAnchor> = ({ drawerOpen }) => (
  <>
    My Account
    <HeaderIcon open={drawerOpen} />
  </>
);
